import React from 'react'

const Services = () => {
  return (
    <section>
            <div className="w3-container" id="services" style={{ marginTop: 75 }}>
      <h1 className="w3-xxxlarge w3-text-red">
        <b>Services.</b>
      </h1>
      <hr style={{ width: 50, border: "5px solid red" }} className="w3-round" />
      <p>
        We are a interior design service that focus on what's best for your home
        and what's best for you!
      </p>
      <p>
        Some text about our services - what we do and what we offer. We are
        lorem ipsum consectetur adipiscing elit, sed do eiusmod tempor
        incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
        quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
        consequat. Duis aute irure dolor in reprehenderit in voluptate velit
        esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
        cupidatat non proident, sunt in culpa qui officia deserunt mollit anim
        id est laborum consectetur adipiscing elit, sed do eiusmod tempor
        incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
        quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
        consequat.
      </p>
    </div>
    </section>
  )
}

export default Services